import moment from 'moment'
import { Storage } from 'loankeeper-common/helpers'
import { setUnauthorizedCallback /* setCustomHeaderFn */ } from 'loankeeper-common/api/callApi'
import { setConfig } from 'loankeeper-common/api/utils'
import { setIconResolver } from 'loankeeper-common/components'

import 'animate.css/animate.min.css'
import 'react-day-picker/lib/style.css'
import 'loankeeper-common/styles/index.scss'
import './styles/index.scss'
import './polyfills'

import { makeAppConfigService } from './api/appConfigService'
import { makeHttpService, applyRequestInterceptors, applyResponseInterceptors, makeApi } from './api'
import { makeStore } from './store'
import { logout, setSTKExpired, setReady, refreshSTK } from './store/auth'
import { getPersistedSession } from './store/persist'
import aliases from './aliases.json'
import { loadTranslations } from './store/translations'

async function setupAuth({ dispatch, getState }) {
  const { STK, STKExpire } = getPersistedSession(getState())

  if (!STK) {
    dispatch(setReady())
    return
  }

  const now = moment()

  if (moment(STKExpire).isAfter(now)) {
    await dispatch(refreshSTK(STK))
  } else {
    await dispatch(logout({ hard: false }))
  }
}

export async function initialize() {
  const http = makeHttpService()

  const appConfigService = makeAppConfigService(http)
  const configResult = await appConfigService.get()
  if (!configResult.success) {
    return false
  }
  const { data: config } = configResult

  document.title = config.appTitle

  setIconResolver((formName, objectName, alias) => {
    let segment

    if (alias && alias in aliases) {
      segment = `common/${String(aliases[alias])}`
    } else if (formName && objectName) {
      segment = `${formName}/${objectName}`
    } else {
      return null
    }

    return `/static/Icons/${segment}.svg`
  })

  const storage = Storage

  const api = makeApi(http, config)
  const store = await makeStore({ api, storage }, { config })

  const translationsResult = await store.dispatch(loadTranslations())
  if (loadTranslations.rejected.match(translationsResult)) {
    return false
  }

  applyRequestInterceptors(http, store, config)
  applyResponseInterceptors(http, store, config)

  setConfig(config.backendUrl + '/', '_api.php?')
  setUnauthorizedCallback(() => {
    // TODO: this has to moved to response interceptors
    store.dispatch([
      logout({
        hard: false,
        reason: 'სესიის დრო ამოიწურა',
      }),
      setSTKExpired(true),
    ])
  })

  await setupAuth(store)

  return { store, storage }
}
